// External modules
import acHTTPClient from 'services/ACHTTPClient';

// Internal modules
import * as constants from '../constants';
import config from '../../../config/config';
import { onAuthError } from '../auth';

// TODO: Use SSM
const experienceAPIURL = `${config.experienceAPIURL}/api/v1`;

const getChallengesBySparkIdError = (error) => {
  return {
    type: constants.GET_CHALLENGES_BY_SPARK_ID_ERROR,
    error,
  };
};

const getChallengesBySparkIdSuccess = (challenges) => {
  return {
    type: constants.GET_CHALLENGES_BY_SPARK_ID_SUCCESS,
    challenges: challenges,
  };
};

const getChallengesBySparkId = (sparkId, isNotInactive) => {
  let apiURL = `${experienceAPIURL}/sparks/${sparkId}/challenges`;
  if (isNotInactive) {
    apiURL += '?isNotInactive=true';
  }
  return (dispatch) => {
    const config = { url: apiURL, method: 'GET' };
    acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(getChallengesBySparkIdError(response.statusText));
        }
        dispatch(getChallengesBySparkIdSuccess(response.data));
      })
      .catch((error) => {
        dispatch(getChallengesBySparkIdError(error));
      });
  };
};

const getChallengesError = (error) => {
  return {
    type: constants.GET_CHALLENGES_ERROR,
    error,
  };
};

const getChallengesSuccess = (challenges) => {
  return {
    type: constants.GET_CHALLENGES_SUCCESS,
    challenges: challenges,
  };
};

const getChallenges = () => {
  let apiURL = `${experienceAPIURL}/challenges`;
  return (dispatch) => {
    const config = { url: apiURL, method: 'GET' };
    acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(getChallengesError(response.statusText));
        }
        dispatch(getChallengesSuccess(response.data));
      })
      .catch((error) => {
        dispatch(getChallengesError(error));
      });
  };
};

const getChallengeByIdError = (error) => {
  return {
    type: constants.GET_CHALLENGE_BY_ID_ERROR,
    error,
  };
};

const getChallengeByIdSuccess = (challenges) => {
  return {
    type: constants.GET_CHALLENGE_BY_ID_SUCCESS,
    challenges: challenges,
  };
};

const getChallengeById = (id) => {
  let apiURL = `${experienceAPIURL}/challenges/${id}`;
  return (dispatch) => {
    const config = { url: apiURL, method: 'GET' };
    acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(getChallengeByIdError(response.statusText));
        }
        dispatch(getChallengeByIdSuccess(response.data));
      })
      .catch((error) => {
        dispatch(getChallengeByIdError(error));
      });
  };
};

const postChallengeError = (error) => {
  return {
    type: constants.POST_CHALLENGE_ERROR,
    error,
  };
};

const postChallengeSuccess = (newId) => {
  return {
    type: constants.POST_CHALLENGE_SUCCESS,
    newId: newId,
  };
};

const postChallenge = (newChallenge) => {
  let apiURL = `${experienceAPIURL}/challenges`;
  return (dispatch) => {
    const config = { url: apiURL, method: 'POST', data: newChallenge };
    acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(postChallengeError(response.statusText));
        }
        dispatch(postChallengeSuccess(response.data));
      })
      .catch((error) => {
        onAuthError(error);
        dispatch(postChallengeError(error));
      });
  };
};

const postChallenges = async (challenges) => {
  const promiseArray = [];
  let apiURL = `${experienceAPIURL}/challenges`;
  challenges.forEach(challenge => {
    promiseArray.push(new Promise((resolve, reject) => {
      const config = { url: apiURL, method: 'POST', data: challenge };
      acHTTPClient.request(config)
        .then(response => {
          return resolve(response.data);
        })
        .catch(error => {
          return reject(error);
        });
    }));
  });
  return await Promise.all(promiseArray).then(res => {
    return res;
  });
}

const patchChallengeError = (error) => {
  return {
    type: constants.PATCH_CHALLENGE_ERROR,
    error,
  };
};

const patchChallengeSuccess = (challenge) => {
  return {
    type: constants.PATCH_CHALLENGE_SUCCESS,
    challenge: challenge,
  };
};

const patchChallenge = (challenge) => {
  let apiURL = `${experienceAPIURL}/challenges/${challenge.id}`;
  return (dispatch) => {
    const config = { url: apiURL, method: 'PATCH', data: challenge };
    acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(patchChallengeError(response.statusText));
        }
        dispatch(patchChallengeSuccess(response.data));
      })
      .catch((error) => {
        onAuthError(error);
        dispatch(patchChallengeError(error));
      });
  };
};

export { getChallenges, getChallengeById, getChallengesBySparkId, postChallenge, postChallenges, patchChallenge };
